type EstimateNode = {
  estimate: any;
  id: string;
  insertedAt: any;
  isWorkerGenerated?: boolean | null | undefined;
};

type EstimateEdge = {
  node: EstimateNode | null | undefined;
};

type Estimates = ReadonlyArray<EstimateEdge | null | undefined> | null | undefined;
export function getSortedEstimates(estimates: Estimates): EstimateNode[] {
  if (!estimates) return [];
  return estimates
    .map((edge) => edge?.node)
    .filter((node): node is EstimateNode => node !== null && node !== undefined)
    .sort((a, b) => new Date(b.insertedAt).getTime() - new Date(a.insertedAt).getTime());
}
